import {
  Box,
  Flex,
  Heading,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { ReactMarkdown, Subheading } from "~/components";


export const SecondPanel = ({ descriptionHome }: { descriptionHome: string }) => {
  const columnWidth = useBreakpointValue({ base: "50vw" });
  return (
    <Flex
      backgroundColor="blue.400"
      py={{ base: "32px", md: "100px" }}
      px={{ base: "40px", md: "72px" }}
      direction={{ base: "row" }}
    >
      <Flex
        gap={{ base: 5, md: 10 }}
        direction={{ base: "column", md: "row" }}
        flexWrap={{ base: "wrap", md: "nowrap" }}
        alignItems="center"
      >
        <Box w={{ base: "100%", md: "50%" }}>
          <Heading
            as="h2"
            fontSize={{ base: "6xl", md: "7xl" }}
            textAlign="center"
          >
            Drive and Discover!
          </Heading>

          <Subheading
            as="p"
            mt={5}
            fontSize={{ base: "3xl" }}
            color="yellow.500"
            textAlign="center"
          >
            the route you take for old stories, new memories & breathtaking
            landscapes
          </Subheading>

          <Flex
            flexDirection={{ base: "row" }}
            justifyContent="center"
            mt={10}
            mb={{ base: 10, md: 14 }}
          >
            <Flex
              // my={{ base: "20px", md: "70px" }}
              w={{ base: "100%" }}
              maxW="240px"
              // h={"100%"}
              aspectRatio={3 / 4}
              borderRadius={{ base: 4, md: 8 }}
              bgImage="/golfkimberly.jpg"
              backgroundSize="cover"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              align="flex-end"
              justify="flex-start"
              shadow="-10px 10px 10px 2px rgba(10, 10, 9, 0.14)"
              transform={{
                base: "rotate(-3deg) translateX(10%)",
                md: "rotate(-3deg)",
              }}
              position="relative"
              zIndex={1}
            >
              {/* <PhotoAttribute>Katie Goldie</PhotoAttribute> */}
            </Flex>

            <Flex
              bgImage="/cgrclimb.jpg"
              backgroundSize="cover"
              backgroundRepeat="no-repeat"
              flexGrow={1}
              aspectRatio={3 / 4}
              w={{ base: "100%" }}
              maxW="240px"
              alignItems="flex-end"
              justifyContent="flex-end"
              backgroundPosition="center"
              borderRadius={{ base: 8, md: 12 }}
              transform={{
                base: "rotate(3deg) translateX(-10%)",
                md: "rotate(3deg) translateY(5%)",
              }}
              shadow="-6px 6px 10px 2px rgba(10, 10, 9, 0.14)"
            >
              {/* <PhotoAttribute>Keri Medig</PhotoAttribute> */}
            </Flex>
          </Flex>
        </Box>

        <Box w={{ base: "100%", md: "50%" }} marginBottom={{ base: 2, md: 5 }}>
          <ReactMarkdown
            components={{
              p: ({ children }) => <Text
                fontSize="md"
                fontWeight="thin"
                whiteSpace="pre-wrap"
                mb={10}
                style={{
                  columnWidth,
                  columnFill: "balance-all",
                }}
              >{children}</Text>,
            }}
          >
            {descriptionHome}
          </ReactMarkdown>
        </Box>
      </Flex>
    </Flex>
  );
};

SecondPanel.displayName = "SwiperSlideSecondPanel";
